import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { formValueSelector } from 'redux-form';
import TitlePage from '../../containers/Header/TitlePage';
import './PatientHome.css';
import PatientHomeNav from './PatientHomeNav';
import DownloadPDF from '../DownloadPDF';
import data from '../data';
import { DownloadCSVComponent } from '../DownloadCSV';
import DownloadCarePlan from '../DownloadCarePlan';
import PatientInfo from './PatientInfo';
import { bindActionCreators } from 'redux';
import { getDTTResponse, getDTTQnaire, load, resetQnaireError } from '../../actions/questionnaire';
import { getRec, loadRec, resetRecError } from '../../actions/recommendations';
import { parseResponse, hasKeys, recResourceToForm } from '../simpleFunctions';
import { BeatLoader } from 'react-spinners';
import { css } from '@emotion/core';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class PatientHome extends Component {
  state = {
    // Use: I think this is used for the pdf render, this was something Zac worked on
    ready: false,
    // Use: to make sure the response form object is loaded only once
    fetched: false,
    // Use: store the compiled answers used for CSV and PDF renders
    finalAnswers: [],
    // Use: to make sure the finalAnswers is compiled only once
    fetchedAnswers: false,
    // Use: fetch the empty skeleton questionnaire resource first, make sure it's loaded into the global state once
    fetchedDTT: false,
    // Use: ???
    singleRender: false,
    // Use: to make sure the recommendations are loaded only once
    fetchedRec: false,
    // Use: sent with redirection to the recommendations page where it uses this value to check if field needs to be repopulated
    newRec: true,
    patientAnswers: [],
    fetchedRec1: false,

  };

  // Use: function to display the "fill out questionnaire" button when DTTResponse is fetched
  responseIsFetched = () => {
    // check whether response is not null or undefined as well as the empty skeleton
    if (hasKeys(this.props, 'questionnaire.fetched') &&
        hasKeys(this.props, 'questionnaire.DTTResponse') &&
        this.props.questionnaire.DTTResponse !== null &&
        hasKeys(this.props, 'questionnaire.DTT')) {
      // return button
      return (
        <Link
          to={{
            pathname: '/questionnairePage/DTT/group/A',
          }}
        >
          <Button color="success" className="question-button">
          Click to Fill Out Questionnaire
          </Button>

        </Link>
      );
    }
    // Use: check if patient is new, meaning the response does not exist in the server yet
    if (this.props.questionnaire.newPatient === true) {
      // return the button regardless
      return (
        <Link
          to={{
            pathname: '/questionnairePage/DTT/group/A',
          }}
        >
          <Button color="success" className="question-button">
            Click to Fill Out Questionnaire
          </Button>

        </Link>
      );
    }
    // if patient is not new, return a spinner to inform user that the response is being fetched from the server
    return (
      <div>
        <BeatLoader
          css={override}
          sizeUnit="px"
          size={30}
          color="#41AAD9"
        />
      </div>

    );
  }

  // Use: function to compile the finalAnswers object that is used for the CSV and PDF components
  finalAnswers = () => {
    const dataItem = this.props.questionnaire.DTT.resource.item;
    const links = [];

    // loop through data to get the question id and push onto a new array called links
    dataItem.forEach((element) => {
      if (element.type === 'group') {
        const groupItem = element.item;
        groupItem.forEach((item) => {
          // let question = item.linkId;
          // question = [`Question ${item.linkId}`];
          const question = [`${element.linkId}${item.linkId}`];
          links.push(question);
        });
      }
    });

    // selector gets all the form values
    const selector = formValueSelector('DTT');
    let formAnswers = (Object.keys(this.props.form).length === 0 && this.props.form.constructor === Object) ? this.props.questionnaire.DTTParsedResponse : selector(this.props, ...links);

    // separate array to get the 'Question No.' of the answers
    const keys = Object.keys(formAnswers);


    const displays = [];

    // map the keys array which has the answers to be in the right format
    const answersWithQuestionId = keys.map((key) => {
      const answers = formAnswers[key];


      // check for array, object, string
      if (answers instanceof Array) {
        const NewArrayofAnswers = answers.map(element => element.display);
        const ArrayAnswer = { id: key, answers: NewArrayofAnswers };
        displays.push(ArrayAnswer);
      } else if (typeof answers === 'object') {
        const ObjectAnswer = { id: key, answers: [answers.display] };
        displays.push(ObjectAnswer);
      } else if (typeof answers === 'string') {
        const StringAnswer = { id: key, answers: [answers] };
        displays.push(StringAnswer);
      } else if (answers === parseInt(answers, 10)) {
        const IntegerAnswer = { id: key, answers: [answers.toString()] };
        displays.push(IntegerAnswer);
      }
      return displays;
    });


    // create new array of unique answers only and flatten the final array of answers
    const RemovedDuplicates = [...new Set(answersWithQuestionId)];
    const FinalAnswers = RemovedDuplicates.reduce((a, b) => a.concat(b), []);
    return FinalAnswers;
  }

  // Use: ???
  singlePDFRender = () => {
    if (this.state.singleRender === false) {
      this.setState({
        singleRender: true,
      });
      return (
        <div />
      );
    }
    return null;
  }

  async componentDidMount() {
    // Use: reset fetched Answers to false
    this.setState({
      fetchedAnswers: false,
    });

    // Use: check if clinician state object is null ...
    //      occurs when the user is not logged in and they try this url path
    if (this.props.user === null) {
      this.props.history.push('/');
      return;
    }
    // react-pdf crashes if a re-render occurs when it's already rendering.
    this.setState({ ready: false });
    setTimeout(() => {
      this.setState({ ready: true });
    }, 1);

    // Set the DTTParsedResponse field in Redux to null to ensure page renders correctly
    await this.props.load(null);
    // reset request errors upon reloading
    await this.props.resetQnaireError();
    // reset request errors upon reloading
    await this.props.resetRecError();
    // call to backend to get Questionnaire Resource
    await this.props.getDTTQnaire();

    // call to backend to get the two types of recommendations
    await this.props.getRec('Follow-Up', this.props.patient.patient.resource.id, this.props.user.id);
    await this.props.getRec('Detailed', this.props.patient.patient.resource.id, this.props.user.id);

    // Use: check if questionnaire resource exists
    // *    This condition will only execute once in every reload due to the local state value being set to "true" after the if condition is true
    // **   Put into a componenDidUpdate() if not done so
    if (hasKeys(this.props, 'questionnaire.DTT.resource.id')) {
      // call backend to get the questionnaire response resource
      await this.props.getDTTResponse(this.props.patient.patient.resource.id, this.props.questionnaire.DTT.resource.id, this.props.questionnaire.DTT.resource.name);
      // Use: set this to true so this if condition only executes once
      this.setState({
        fetchedDTT: true,
      });
    }

    // Use: check if questionnaire resource and questionnaire response resource have been fetched
    // *    This condition will only execute once in every reload due to the local state value being set to "true" after the if condition is true
    // **   Put into a componenDidUpdate() if not done so
    if (hasKeys(this.props, 'questionnaire.DTTResponse.id') &&
        hasKeys(this.props, 'questionnaire.DTT.resource.id')) {

      // Use: create the form object based on the retrieved response resource
      // Parse practitioner response
      const testInitializer = parseResponse(this.props.questionnaire.DTTResponse, this.props.questionnaire.DTT.resource, false);
      // load into the form object in the state
      await this.props.load(testInitializer);

      // Use: set to true after the above has occured so this if condition doesn't execute again
      this.setState({
        fetched: true,
      });
    }

    // Use: check if the questionnaire resource exists and that the form object has been loaded using the questionnaire response resource
    // *    This condition will only execute once in every reload due to the local state value being set to "true" after the if condition is true
    // **   Put into a componenDidUpdate() if not done so
    if (hasKeys(this.props, 'questionnaire.DTT.resource.id') &&
        this.props.questionnaire.DTTParsedResponse !== null &&
        this.props.questionnaire.DTTParsedResponse !== undefined) {
      // Use: compile the final Answers (only used for CSV and PDF components)
      const answers = this.finalAnswers(false);
      const pAnswers = this.finalAnswers(true);
      // Use: set both local finalAnswers and fetched states
      this.setState({
        finalAnswers: answers,
        patientAnswers: pAnswers,
        fetchedAnswers: true,
      });
    }

    // Use: check if the recommendations have been fetched before mapping the resource object to the form object
    // *    This condition will only execute once in every reload due to the local state value being set to "true" after the if condition is true
    // **   Put into a componenDidUpdate() if not done so
    if (hasKeys(this.props, 'recommendations.followUp.resource') &&
        hasKeys(this.props, 'recommendations.detailed.resource')) {
      /*
      * Reasoning for the parameter values:
      * - this.props.recommendations.followUp.resource.valueString: extracted follow-up value of the textbox to load into the form object for recommendations
      * - this.props.recommendations.detailed.resource.valueString: extracted detailed value of the textbox to load into the form object for recommendations
      */
      // Use: create the form object for recommendations based on the retrieved values from the server
      const formValue = await recResourceToForm(this.props.recommendations.followUp.resource.valueString, this.props.recommendations.detailed.resource.valueString);

      // load the form object into the global state
      await this.props.loadRec(formValue);
      // mark that recommendations have loaded to site can prefill correctly
      this.setState({
        newRec: false
      })
    }
    this.setState({
      fetchedRec: true,
    });
  }

  render() {
    const { ready } = this.state;

    // Use: If any of the backend request responds with an error then redirect user to the landing page
    if (this.props.user == null) {
      this.props.history.push('/');

      return null;
    }
    if (this.props.questionnaire.error === '' || this.props.user.error === '' || this.props.patient.error === '') {
      this.props.history.push('/');
      return null;
    }
    // Redirect to front page if user has been logged out (i.e. DTT.errorCode != null)
    if (this.state.fetchedRec === true && this.props.questionnaire.DTT !== undefined && this.props.questionnaire.DTT !== null && this.props.questionnaire.DTT.errorCode !== undefined) {
      this.props.history.push('/');
      return null;
    }


    // // Use: check if the recommendations have been fetched before mapping the resource object to the form object
    // // *    This condition will only execute once in every reload due to the local state value being set to "true" after the if condition is true
    // // **   Put into a componenDidUpdate() if not done so
    // if (hasKeys(this.props, 'recommendations.followUp.resource') &&
    //     hasKeys(this.props, 'recommendations.detailed.resource') &&
    //     this.state.fetchedRec1 === false) {
    //   /*
    //   * Reasoning for the parameter values:
    //   * - this.props.recommendations.followUp.resource.valueString: extracted follow-up value of the textbox to load into the form object for recommendations
    //   * - this.props.recommendations.detailed.resource.valueString: extracted detailed value of the textbox to load into the form object for recommendations
    //   */
    //   // Use: create the form object for recommendations based on the retrieved values from the server
    //   const formValue = recResourceToForm(this.props.recommendations.followUp.resource.valueString, this.props.recommendations.detailed.resource.valueString);

    //   // load the form object into the global state
    //   this.props.loadRec(formValue);
    //   // Use: set both local newRec and fetched states
    //   this.setState({
    //     fetchedRec1: true,
    //     newRec: false,
    //   });
    // }


    if (this.state.fetchedRec === false) {
      //TODO: Make this nicer
      return (
        <div>Waiting to retrieve data...</div>
      );
    }

    return (
      <div className="patientinfopage">
        <TitlePage />
        <PatientHomeNav history={this.props.history} />
        {ready && (
          <div className="patientinfocontainer">
            <PatientInfo {...this.props} />
            <div>
              <h1>Questionnaire</h1>
              <div className="answerbuttons">
                {!this.props.questionnaire.fetching ?
                  this.responseIsFetched() :
                  <div>
                    <BeatLoader
                      css={override}
                      sizeUnit="px"
                      size={30}
                      color="#41AAD9"
                    />
                  </div>
                }
                {this.state.finalAnswers.length !== 0 && this.state.patientAnswers !== 0 ?
                  <div>
                    <DownloadCSVComponent patient={false} data={data} answers={this.state.finalAnswers} />
                    <DownloadPDF data={data} answers={this.state.finalAnswers} {...this.props} />
                  </div>
                  :
                  null}

              </div>
            </div>
            <div>
              <h1>Care Plan</h1>
              <div className="answersbuttons">
                <React.Fragment>
                  {ready &&
                  hasKeys(this.props, 'questionnaire.fetched') &&
                  hasKeys(this.props, 'questionnaire.DTTResponse') &&
                  // this.props.questionnaire.response !== null &&
                  // hasKeys(this.props, 'questionnaire.DTTParsedResponse.A1') &&
                  hasKeys(this.props, 'questionnaire.DTT')// &&
                  // this.state.finalAnswers.length !== 0
                    ?
                      <div>
                      {this.props.questionnaire.DTTParsedResponse !== null ?
                          <Link
                          to={{
                            pathname: '/recommendations',
                            new: this.state.newRec,
                          }}
                        >
                          <Button color="success" className="question-button">
                      Click to Fill Out Recommendations OLD
                            </Button>
                        </Link>
                        :
                        <div>
                            {this.props.questionnaire.newPatient === false ?
                            <div>
                                <BeatLoader
                                css={override}
                                sizeUnit="px"
                                size={30}
                                color="#41AAD9"
                              />
                              </div>

                            : <div>Please fill out questionnaire</div>}
                          </div>
                      }

                      {this.props.questionnaire.DTTParsedResponse !== null ?
                          <Link
                          to={{
                            pathname: '/questionnairePage/Recommendation/group/A',
                            new: this.state.newRec,
                          }}
                        >
                          <Button color="success" className="question-button">
                      Click to Fill Out Recommendations
                            </Button>
                        </Link>
                        :
                        <div>
                            {this.props.questionnaire.newPatient === false ?
                            <div>
                                <BeatLoader
                                css={override}
                                sizeUnit="px"
                                size={30}
                                color="#41AAD9"
                              />
                              </div>

                            : <div></div>}
                          </div>
                      }

                      {ready && this.state.fetchedRec && this.props.recommendations.followUp != null && this.state.finalAnswers.length !== 0 &&
                        <DownloadCarePlan answers={this.state.finalAnswers} data={data} {...this.props} />
                      }
                    </div>
                    :
                    <div>
                        <BeatLoader
                        css={override}
                        sizeUnit="px"
                        size={30}
                        color="#41AAD9"
                      />
                      </div>

                  }

                </React.Fragment>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state =>
  ({
    patient: state.patient,
    user: state.clinician.clinician,
    router: state.router,
    form: state.form,
    recommendations: state.recommendations,
    questionnaire: state.questionnaire,
    userDetails: state.userDetails,
    recipientDetails: state.recipientDetails,
  });

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getDTTResponse,
      getDTTQnaire,
      load,
      getRec,
      loadRec,
      resetQnaireError,
      resetRecError,

    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PatientHome);



// WEBPACK FOOTER //
// ./src/components/PatientHome/PatientHome.js